import React from "react";
import { Col, Row, Card } from "react-bootstrap";
import "./annualsalaryeditmodal.scss";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";
import shuffleImage from "../../assets/shuffle.png";
import FormFields from "../../atoms/FormFields";
import { addCommas } from "../../helpers/helpers";
const AnnualSalaryModal = (props) => {
  const changeForecast = (event) => {
    let rawValue = event.target.value.replace(/[£,]/g, ""); // Remove £ and commas

    // If input is empty or not a number, default to 0
    const numericValue =
      rawValue === "" ? 0 : Number(rawValue.replace(/\D/g, ""));

    const formattedValue = numericValue; // Add commas
    props.setAnnualSalary(formattedValue); // Store raw number (e.g., 100000)
  };

  const btnDoneHandler = () => {
    props.setAnnualSalaryEditModal(false);
  };
  return (
    <div className="edit-modal-container">
      <div className="pensionable-edit-close">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <p className="title text-center">{props.modalTitle}</p>
      <p className="text-center description desktop-description">
        {`${props.description.split(".")[0]}.`}
        <br />
        {`${props.description.split(".")[1]}.`}
      </p>
      <p className="text-center description mobile-description">
        {props.description}
      </p>
      <Card className="mt-5">
        <Row>
          <Col xs={12} sm={6} md={6} className="adjust-income">
            <Row>
              <Col xs={2} className="shuffle-img">
                <img src={shuffleImage} alt="shuffle" />
              </Col>
              <Col xs={10}>
                <p className="sub-heading">{props.subHeading}</p>
                <p className="sub-description">{props.subDescription}</p>
              </Col>
            </Row>
          </Col>
          <Col xs={12} sm={6} md={6}>
            <Row>
              <Col className="text-end">
                <FormFields
                  Label="Current annual pensionable salary"
                  disabled={true}
                  value={`£${addCommas(parseInt(props.actualAnnualSalary))}`}
                  variant="form-field-default"
                  placeholder=""
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col className="text-end">
                <FormFields
                  Label="Earnings for this forecast"
                  disabled={false}
                  value={`£${addCommas(props.annualSalary || 0)}`}
                  variant="form-field-default"
                  changeHandler={changeForecast}
                  maxLength={40}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} className="text-start">
            <Buttons
              name="Back"
              className="secondary"
              handleClick={props.btnBackHandler}
            />
          </Col>
          <Col xs={6} className="text-end">
            <Buttons
              name="Done"
              className="primary"
              handleClick={btnDoneHandler}
            />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default AnnualSalaryModal;
